export function simplifyDataStructureReplacer(_, value) {
    if (value instanceof Set)
        return [...value];
    if (value instanceof Map)
        return Object.fromEntries([...value]);
    return value;
}
export function getCircularSimplifyDataStructureReplacer() {
    const ancestors = [];
    return function (key, value) {
        if (typeof value !== "object" || value === null)
            return value;
        while (ancestors.length > 0 && ancestors[ancestors.length - 1] !== this) {
            ancestors.pop();
        }
        if (ancestors.includes(value))
            return "[Circular]";
        ancestors.push(value);
        return simplifyDataStructureReplacer(key, value);
    };
}
//# sourceMappingURL=simplifyDataStructureReplacer.js.map